import * as React from "react";
import PageLayout from "../../components/Shared/PageLayout";
import { EDPageLoader, grey } from "@trailblazer-game/ed-webkit";
import dynamic from "next/dynamic";
import { useRouter } from "next/router";

const Tournament = dynamic(() => import("../../components/Pages/Tournament/Public/Tournament"), {
    suspense: false,
    ssr: false,
    loading: () => <EDPageLoader in={true}/>,
})

export default function TournamentPage() {
    const router = useRouter();
    const { tournamentId } = router.query;

    return <PageLayout backgroundColor={grey("1000")}>
        <Tournament tournamentId={(tournamentId as string) || ""}/>
    </PageLayout>
}

TournamentPage.metaData = {
    title: 'Eternal Dragons - Join the Ultimate Dragon Tournament',
    image: "https://cdn.eternaldragons.com/assets/tournament_og_image.png",
    description: 'Participate in thrilling Dragon Tournaments in Eternal Dragons. Compete against skilled opponents and vie for the title of Dragon Master. Conquer the arena and claim your rightful place in dragon history!'
}